/**
 * Which variant is the shopper actually looking at?
 *
 * A surprisingly hard question in this theme, and one that was being answered
 * twice — once in snippets/mediaclip-theme-picker.liquid and once in
 * snippets/pixfizz-launch-product-handler.liquid — with two different orders of
 * preference. They diverged, and a customizer was launched for the variant the
 * shopper had left rather than the one on screen. One answer, one place.
 *
 * The difficulty comes from the theme itself: the native add-to-cart form is
 * rendered ONLY on non-customizable products (see the customization:1 tests in
 * snippets/product.liquid). So on exactly the pages that launch a customizer,
 * the obvious source — the add-to-cart form — does not exist. The selection has
 * to be recovered from whatever else the page keeps up to date.
 *
 * Three sources, in this order, each chosen for a reason learned the hard way:
 *
 *   1. input[name="id"] — the input the theme keeps in step with the variant
 *      picker. Searched across the whole document on purpose: with no
 *      product-buttons form, the only one left lives in the instalment form
 *      from snippets/product-price.liquid. It is the only source that survives
 *      a back navigation, because it reflects the DOM the shopper can see.
 *
 *   2. The ?variant= URL parameter. Reliable the moment the shopper switches
 *      variant — the theme updates it before the inputs — but NOT after a back
 *      navigation, where the restored history entry can lack the parameter
 *      entirely while the page still shows the last selection.
 *
 *   3. A caller-supplied fallback, normally
 *      product.selected_or_first_available_variant.id rendered by Liquid. It is
 *      frozen at render time, so it is always the first variant: reaching it
 *      means both live sources failed, and the answer is probably wrong.
 *
 * Returns { id, source }. `source` exists so the debug mode can show which one
 * answered — that is what turned a two-hour hunt into a three-line log.
 */
(function () {
  'use strict';

  window.tipiiVariant = {
    /**
     * @param {Object} [options]
     * @param {Element} [options.scope]     Element to search first, typically the
     *                                      <product-info> holding the clicked button.
     *                                      Guards against a stale section left in the DOM.
     * @param {string|number} [options.fallback]  Value to use when nothing live is found.
     * @returns {{id: (string|number|null), source: string}}
     */
    current: function (options) {
      options = options || {};
      var scope = options.scope || document;

      var input =
        (scope.querySelector && scope.querySelector('input[name="id"]')) ||
        document.querySelector('input[name="id"]') ||
        document.querySelector('input.product-variant-id');

      if (input && input.value) {
        return { id: input.value, source: 'input id' };
      }

      var urlVariant = null;
      try {
        urlVariant = new URL(window.location.href).searchParams.get('variant');
      } catch (e) {
        /* URL unavailable — fall through */
      }
      if (urlVariant) {
        return { id: urlVariant, source: 'url' };
      }

      if (options.fallback) {
        return { id: options.fallback, source: 'liquid fallback' };
      }

      return { id: null, source: 'none' };
    },
  };
})();
